export const videoUrlRegex: RegExp =
  /https?:\/\/[^\s"']+\.(?:mp4|webm|ogg|mov|m4v|flv|mkv)/;
